import { usePublishTemplateMutation } from '../../../../generated/graphql'
import useModal from '../../../../lib/hooks/useModal'
import { ConfirmPublishTemplateModal } from '../../templateModals'
import useNotification from '../../../../lib/hooks/useNotification'

type ConfirmPublishTemplateModalWrapperProps = {
  /** ID of Plan */
  id: string
  /** Determines visibility of modal */
  isOpen: boolean
}

const ConfirmPublishTemplateModalWrapper = ({
  id,
  isOpen
}: ConfirmPublishTemplateModalWrapperProps) => {
  const { hideModal } = useModal()
  const { showErrorNotif } = useNotification()

  const [publishPlan, mutation] = usePublishTemplateMutation({
    variables: { input: id },
    onError: () => {
      hideModal()
      showErrorNotif('Template could not be published.', publishPlan)
    }
  })

  const onConfirm = () => {
    hideModal()
    publishPlan()
  }

  if (!mutation.called) {
    return <ConfirmPublishTemplateModal isOpen={isOpen} onConfirm={onConfirm} label="Template" />
  }

  return null
}

export default ConfirmPublishTemplateModalWrapper
